import { useEffect, useState } from 'react';
import { TextField, List, ListItem, Typography, Button, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';


import { getTiers } from '../api/tiers';

import Modal from '@mui/material/Modal';
import { useData } from '../hooks/DataProvider';
import translations from '../scripts/translations';


const SearchBlock = ({ fields, options, handleSelect, clear }) => {

    const { language } = useData();
    const page = translations.components.searchBox[language];
    const button = translations.button[language];

    const { searchByCode, setSearchByCode, searchByName, setSearchByName } = fields;

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <TextField
                        label={page.searchByCode}
                        id="test-field"
                        value={searchByCode}
                        onChange={(e) => setSearchByCode(e.target.value)}
                        variant="outlined"
                        size="small"
                        slotProps={{ inputLabel: { shrink: true } }}
                    />
                    <TextField
                        label={page.searchByName}
                        id="test-field"
                        value={searchByName}
                        onChange={(e) => setSearchByName(e.target.value)}
                        variant="outlined"
                        size="small"
                        slotProps={{ inputLabel: { shrink: true } }}
                    />
                    <Button variant="outlined"  onClick={clear} style={{ textTransform: "none" }}>
                    {button.reset}
                </Button>
                </Box>
                
            </Box>



            <List >
                {options.map((option) => (
                    <ListItem
                        key={option._id}
                        onClick={() => handleSelect(option)}
                        disablePadding
                        sx={{
                            cursor: 'pointer',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            padding: '8px',
                            mb: '4px',
                            display: 'grid',
                            gridTemplateColumns: '1fr 1.5fr .5fr  1fr 2fr 2fr',
                            gap: '8px',
                            maxHeight: '100px',
                            overflow: 'hidden',
                        }} >
                        <Typography variant="subtitle1" >{option.code}</Typography>
                        <Typography variant="subtitle1" >{option.name}</Typography>
                        <Typography variant="subtitle1" >{option.countryCode}</Typography>
                        <Typography variant="subtitle1" >{option.zipCode}</Typography>
                        <Typography variant="subtitle1" >{option.city}</Typography>
                        <Typography variant="subtitle1" >{option.address}</Typography>
                    </ListItem>
                ))}
            </List>
        </>
    );
}


const TierSearchBox = ({ data, update, filed, forDocument }) => {

    const { language } = useData();
    const button = translations.button[language];

    const [searchByCode, setSearchByCode] = useState('');
    const [searchByName, setSearchByName] = useState('');
    const [options, setOptions] = useState([]);

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const style = {
        position: 'absolute',
        top: '20%',
        left: '20%',
        transform: 'translate(-20%, -20%)',
        width: '80%',
        bgcolor: 'background.paper',
        // border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        borderRadius: '8px',
        // height: '80vh',
        minHeight: '300px',
        height: '80vh',
        overflowY: 'auto',
    };

    const clear = () => {
        setSearchByCode('');
        setSearchByName('');
        setOptions([]);
    }

    let fields = {
        searchByCode: searchByCode,
        setSearchByCode: setSearchByCode,
        searchByName: searchByName,
        setSearchByName: setSearchByName,
    }

    const filter = () => {
        let f = {}
        if (searchByCode) f.code = searchByCode;
        if (searchByName) f.name = searchByName;
        return f;
    }

    useEffect(() => {
        const fetchTiers = async () => {
            try {
                const response = await getTiers({  ...filter() });
                setOptions(response)
                console.log('Tiers fetched:', response);
            } catch (error) {
                console.error('Error fetching tiers:', error);
            }
        };
        // fetchTiers()
        if (searchByCode.length > 1 || searchByName.length > 1) fetchTiers();
        if (!searchByCode && !searchByName) setOptions([]); // Clear options if input is empty

    }, [searchByCode, searchByName]);


    const handleSelect = (option) => {
        console.log('Selected option:', option);
        // You can perform any action with the selected option here
        const tier = {
            _id: option._id,
            code: option.code,
            name: option.name,
            countryCode: option.countryCode,
            country: option.country,
            zipCode: option.zipCode,
            city: option.city,
            address: option.address,
            address2: option?.address2 || '',   
        }

        if (forDocument) {
            tier['siret'] = option.siret || '';
            tier['tva'] = option.tva || '';
        }

        if (!data.consignee?._id && filed === 'orderingParty') {
            update({ ...data, [filed]: tier, consignee: tier });
        }
        else {
            update({ ...data, [filed]: tier });
        }
        // update({ ...data, [filed]: tier });
        clear()
        handleClose();
    }


    return (
        <>

            <Button size='small' onClick={handleOpen} variant='outlined' style={{ textTransform: "none", minWidth: "40px" }} ><SearchIcon fontSize='small' /></Button>
            <Button size='small' onClick={() => { update({ ...data, [filed]: {} }) }} variant='outlined' style={{ textTransform: "none", minWidth: "40px" }} ><ClearIcon fontSize='small' /></Button>

            <Modal
                open={open}
                onClose={handleClose}
            >
                <Box sx={style}>
                    <SearchBlock
                        // id="modal-modal-description"
                        fields={fields}
                        options={options}
                        handleSelect={handleSelect}
                        clear={clear}
                    />
                    <Button variant="outlined" onClick={handleClose} sx={{ mt: 2 }}>{button.close}</Button>
                </Box>
            </Modal>

        </>
    );
}

export { TierSearchBox };
